/*! @license DOMPurify 3.2.6 | (c) Cure53 and other contributors | Released under the Apache license 2.0 and Mozilla Public License 2.0 | github.com/cure53/DOMPurify/blob/3.2.6/LICENSE */
var Pe, St;
function dn() {
  if (St) return Pe;
  St = 1;
  const {
    entries: ve,
    setPrototypeOf: ke,
    isFrozen: Rt,
    getPrototypeOf: yt,
    getOwnPropertyDescriptor: Ot
  } = Object;
  let {
    freeze: g,
    seal: O,
    create: Ue
  } = Object, {
    apply: ue,
    construct: me
  } = typeof Reflect < "u" && Reflect;
  g || (g = function(o) {
    return o;
  }), O || (O = function(o) {
    return o;
  }), ue || (ue = function(o, l, s) {
    return o.apply(l, s);
  }), me || (me = function(o, l) {
    return new o(...l);
  });
  const Q = A(Array.prototype.forEach), Lt = A(Array.prototype.lastIndexOf), Fe = A(Array.prototype.pop), G = A(Array.prototype.push), Dt = A(Array.prototype.splice), ee = A(String.prototype.toLowerCase), pe = A(String.prototype.toString), He = A(String.prototype.match), W = A(String.prototype.replace), Nt = A(String.prototype.indexOf), bt = A(String.prototype.trim), L = A(Object.prototype.hasOwnProperty), h = A(RegExp.prototype.test), B = It(TypeError);
  function A(r) {
    return function(o) {
      o instanceof RegExp && (o.lastIndex = 0);
      for (var l = arguments.length, s = new Array(l > 1 ? l - 1 : 0), T = 1; T < l; T++)
        s[T - 1] = arguments[T];
      return ue(r, o, s);
    };
  }
  function It(r) {
    return function() {
      for (var o = arguments.length, l = new Array(o), s = 0; s < o; s++)
        l[s] = arguments[s];
      return me(r, l);
    };
  }
  function a(r, o) {
    let l = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : ee;
    ke && ke(r, null);
    let s = o.length;
    for (; s--; ) {
      let T = o[s];
      if (typeof T == "string") {
        const b = l(T);
        b !== T && (Rt(o) || (o[s] = b), T = b);
      }
      r[T] = !0;
    }
    return r;
  }
  function Mt(r) {
    for (let o = 0; o < r.length; o++)
      L(r, o) || (r[o] = null);
    return r;
  }
  function N(r) {
    const o = Ue(null);
    for (const [l, s] of ve(r))
      L(r, l) && (Array.isArray(s) ? o[l] = Mt(s) : s && typeof s == "object" && s.constructor === Object ? o[l] = N(s) : o[l] = s);
    return o;
  }
  function Y(r, o) {
    for (; r !== null; ) {
      const s = Ot(r, o);
      if (s) {
        if (s.get)
          return A(s.get);
        if (typeof s.value == "function")
          return A(s.value);
      }
      r = yt(r);
    }
    function l() {
      return null;
    }
    return l;
  }
  const ze = g(["a", "abbr", "acronym", "address", "area", "article", "aside", "audio", "b", "bdi", "bdo", "big", "blink", "blockquote", "body", "br", "button", "canvas", "caption", "center", "cite", "code", "col", "colgroup", "content", "data", "datalist", "dd", "decorator", "del", "details", "dfn", "dialog", "dir", "div", "dl", "dt", "element", "em", "fieldset", "figcaption", "figure", "font", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hgroup", "hr", "html", "i", "img", "input", "ins", "kbd", "label", "legend", "li", "main", "map", "mark", "marquee", "menu", "menuitem", "meter", "nav", "nobr", "ol", "optgroup", "option", "output", "p", "picture", "pre", "progress", "q", "rp", "rt", "ruby", "s", "samp", "section", "select", "shadow", "small", "source", "spacer", "span", "strike", "strong", "style", "sub", "summary", "sup", "table", "tbody", "td", "template", "textarea", "tfoot", "th", "thead", "time", "tr", "track", "tt", "u", "ul", "var", "video", "wbr"]), de = g(["svg", "a", "altglyph", "altglyphdef", "altglyphitem", "animatecolor", "animatemotion", "animatetransform", "circle", "clippath", "defs", "desc", "ellipse", "filter", "font", "g", "glyph", "glyphref", "hkern", "image", "line", "lineargradient", "marker", "mask", "metadata", "mpath", "path", "pattern", "polygon", "polyline", "radialgradient", "rect", "stop", "style", "switch", "symbol", "text", "textpath", "title", "tref", "tspan", "view", "vkern"]), Te = g(["feBlend", "feColorMatrix", "feComponentTransfer", "feComposite", "feConvolveMatrix", "feDiffuseLighting", "feDisplacementMap", "feDistantLight", "feDropShadow", "feFlood", "feFuncA", "feFuncB", "feFuncG", "feFuncR", "feGaussianBlur", "feImage", "feMerge", "feMergeNode", "feMorphology", "feOffset", "fePointLight", "feSpecularLighting", "feSpotLight", "feTile", "feTurbulence"]), Ct = g(["animate", "color-profile", "cursor", "discard", "font-face", "font-face-format", "font-face-name", "font-face-src", "font-face-uri", "foreignobject", "hatch", "hatchpath", "mesh", "meshgradient", "meshpatch", "meshrow", "missing-glyph", "script", "set", "solidcolor", "unknown", "use"]), _e = g(["math", "menclose", "merror", "mfenced", "mfrac", "mglyph", "mi", "mlabeledtr", "mmultiscripts", "mn", "mo", "mover", "mpadded", "mphantom", "mroot", "mrow", "ms", "mspace", "msqrt", "mstyle", "msub", "msup", "msubsup", "mtable", "mtd", "mtext", "mtr", "munder", "munderover", "mprescripts"]), wt = g(["maction", "maligngroup", "malignmark", "mlongdiv", "mscarries", "mscarry", "msgroup", "mstack", "msline", "msrow", "semantics", "annotation", "annotation-xml", "mprescripts", "none"]), Ge = g(["#text"]), We = g(["accept", "action", "align", "alt", "autocapitalize", "autocomplete", "autopictureinpicture", "autoplay", "background", "bgcolor", "border", "capture", "cellpadding", "cellspacing", "checked", "cite", "class", "clear", "color", "cols", "colspan", "controls", "controlslist", "coords", "crossorigin", "datetime", "decoding", "default", "dir", "disabled", "disablepictureinpicture", "disableremoteplayback", "download", "draggable", "enctype", "enterkeyhint", "face", "for", "headers", "height", "hidden", "high", "href", "hreflang", "id", "inputmode", "integrity", "ismap", "kind", "label", "lang", "list", "loading", "loop", "low", "max", "maxlength", "media", "method", "min", "minlength", "multiple", "muted", "name", "nonce", "noshade", "novalidate", "nowrap", "open", "optimum", "pattern", "placeholder", "playsinline", "popover", "popovertarget", "popovertargetaction", "poster", "preload", "pubdate", "radiogroup", "readonly", "rel", "required", "rev", "reversed", "role", "rows", "rowspan", "spellcheck", "scope", "selected", "shape", "size", "sizes", "span", "srclang", "start", "src", "srcset", "step", "style", "summary", "tabindex", "title", "translate", "type", "usemap", "valign", "value", "width", "wrap", "xmlns", "slot"]), Ee = g(["accent-height", "accumulate", "additive", "alignment-baseline", "amplitude", "ascent", "attributename", "attributetype", "azimuth", "basefrequency", "baseline-shift", "begin", "bias", "by", "class", "clip", "clippathunits", "clip-path", "clip-rule", "color", "color-interpolation", "color-interpolation-filters", "color-profile", "color-rendering", "cx", "cy", "d", "dx", "dy", "diffuseconstant", "direction", "display", "divisor", "dur", "edgemode", "elevation", "end", "exponent", "fill", "fill-opacity", "fill-rule", "filter", "filterunits", "flood-color", "flood-opacity", "font-family", "font-size", "font-size-adjust", "font-stretch", "font-style", "font-variant", "font-weight", "fx", "fy", "g1", "g2", "glyph-name", "glyphref", "gradientunits", "gradienttransform", "height", "href", "id", "image-rendering", "in", "in2", "intercept", "k", "k1", "k2", "k3", "k4", "kerning", "keypoints", "keysplines", "keytimes", "lang", "lengthadjust", "letter-spacing", "kernelmatrix", "kernelunitlength", "lighting-color", "local", "marker-end", "marker-mid", "marker-start", "markerheight", "markerunits", "markerwidth", "maskcontentunits", "maskunits", "max", "mask", "media", "method", "mode", "min", "name", "numoctaves", "offset", "operator", "opacity", "order", "orient", "orientation", "origin", "overflow", "paint-order", "path", "pathlength", "patterncontentunits", "patterntransform", "patternunits", "points", "preservealpha", "preserveaspectratio", "primitiveunits", "r", "rx", "ry", "radius", "refx", "refy", "repeatcount", "repeatdur", "restart", "result", "rotate", "scale", "seed", "shape-rendering", "slope", "specularconstant", "specularexponent", "spreadmethod", "startoffset", "stddeviation", "stitchtiles", "stop-color", "stop-opacity", "stroke-dasharray", "stroke-dashoffset", "stroke-linecap", "stroke-linejoin", "stroke-miterlimit", "stroke-opacity", "stroke", "stroke-width", "style", "surfacescale", "systemlanguage", "tabindex", "tablevalues", "targetx", "targety", "transform", "transform-origin", "text-anchor", "text-decoration", "text-rendering", "textlength", "type", "u1", "u2", "unicode", "values", "viewbox", "visibility", "version", "vert-adv-y", "vert-origin-x", "vert-origin-y", "width", "word-spacing", "wrap", "writing-mode", "xchannelselector", "ychannelselector", "x", "x1", "x2", "xmlns", "y", "y1", "y2", "z", "zoomandpan"]), Be = g(["accent", "accentunder", "align", "bevelled", "close", "columnsalign", "columnlines", "columnspan", "denomalign", "depth", "dir", "display", "displaystyle", "encoding", "fence", "frame", "height", "href", "id", "largeop", "length", "linethickness", "lspace", "lquote", "mathbackground", "mathcolor", "mathsize", "mathvariant", "maxsize", "minsize", "movablelimits", "notation", "numalign", "open", "rowalign", "rowlines", "rowspacing", "rowspan", "rspace", "rquote", "scriptlevel", "scriptminsize", "scriptsizemultiplier", "selection", "separator", "separators", "stretchy", "subscriptshift", "supscriptshift", "symmetric", "voffset", "width", "xmlns"]), te = g(["xlink:href", "xml:id", "xlink:title", "xml:space", "xmlns:xlink"]), xt = O(/\{\{[\w\W]*|[\w\W]*\}\}/gm), Pt = O(/<%[\w\W]*|[\w\W]*%>/gm), vt = O(/\$\{[\w\W]*/gm), kt = O(/^data-[\-\w.\u00B7-\uFFFF]+$/), Ut = O(/^aria-[\-\w]+$/), Ye = O(
    /^(?:(?:(?:f|ht)tps?|mailto|tel|callto|sms|cid|xmpp|matrix):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i
    // eslint-disable-line no-useless-escape
  ), Ft = O(/^(?:\w+script|data):/i), Ht = O(
    /[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g
    // eslint-disable-line no-control-regex
  ), Xe = O(/^html$/i), zt = O(/^[a-z][.\w]*(-[.\w]+)+$/i);
  var je = /* @__PURE__ */ Object.freeze({
    __proto__: null,
    ARIA_ATTR: Ut,
    ATTR_WHITESPACE: Ht,
    CUSTOM_ELEMENT: zt,
    DATA_ATTR: kt,
    DOCTYPE_NAME: Xe,
    ERB_EXPR: Pt,
    IS_ALLOWED_URI: Ye,
    IS_SCRIPT_OR_DATA: Ft,
    MUSTACHE_EXPR: xt,
    TMPLIT_EXPR: vt
  });
  const X = {
    element: 1,
    text: 3,
    // Deprecated
    progressingInstruction: 7,
    comment: 8,
    document: 9
  }, Gt = function() {
    return typeof window > "u" ? null : window;
  }, Wt = function(o, l) {
    if (typeof o != "object" || typeof o.createPolicy != "function")
      return null;
    let s = null;
    const T = "data-tt-policy-suffix";
    l && l.hasAttribute(T) && (s = l.getAttribute(T));
    const b = "dompurify" + (s ? "#" + s : "");
    try {
      return o.createPolicy(b, {
        createHTML(x) {
          return x;
        },
        createScriptURL(x) {
          return x;
        }
      });
    } catch {
      return console.warn("TrustedTypes policy " + b + " could not be created."), null;
    }
  }, Ve = function() {
    return {
      afterSanitizeAttributes: [],
      afterSanitizeElements: [],
      afterSanitizeShadowDOM: [],
      beforeSanitizeAttributes: [],
      beforeSanitizeElements: [],
      beforeSanitizeShadowDOM: [],
      uponSanitizeAttribute: [],
      uponSanitizeElement: [],
      uponSanitizeShadowNode: []
    };
  };
  function qe() {
    let r = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : Gt();
    const o = (i) => qe(i);
    if (o.version = "3.2.6", o.removed = [], !r || !r.document || r.document.nodeType !== X.document || !r.Element)
      return o.isSupported = !1, o;
    let {
      document: l
    } = r;
    const s = l, T = s.currentScript, {
      DocumentFragment: b,
      HTMLTemplateElement: x,
      Node: ge,
      Element: $e,
      NodeFilter: j,
      NamedNodeMap: Yt = r.NamedNodeMap || r.MozNamedAttrMap,
      HTMLFormElement: Xt,
      DOMParser: jt,
      trustedTypes: ne
    } = r, V = $e.prototype, Vt = Y(V, "cloneNode"), qt = Y(V, "remove"), $t = Y(V, "nextSibling"), Kt = Y(V, "childNodes"), oe = Y(V, "parentNode");
    if (typeof x == "function") {
      const i = l.createElement("template");
      i.content && i.content.ownerDocument && (l = i.content.ownerDocument);
    }
    let S, q = "";
    const {
      implementation: he,
      createNodeIterator: Zt,
      createDocumentFragment: Jt,
      getElementsByTagName: Qt
    } = l, {
      importNode: en
    } = s;
    let R = Ve();
    o.isSupported = typeof ve == "function" && typeof oe == "function" && he && he.createHTMLDocument !== void 0;
    const {
      MUSTACHE_EXPR: Ae,
      ERB_EXPR: Se,
      TMPLIT_EXPR: Re,
      DATA_ATTR: tn,
      ARIA_ATTR: nn,
      IS_SCRIPT_OR_DATA: on,
      ATTR_WHITESPACE: Ke,
      CUSTOM_ELEMENT: an
    } = je;
    let {
      IS_ALLOWED_URI: Ze
    } = je, m = null;
    const Je = a({}, [...ze, ...de, ...Te, ..._e, ...Ge]);
    let d = null;
    const Qe = a({}, [...We, ...Ee, ...Be, ...te]);
    let f = Object.seal(Ue(null, {
      tagNameCheck: {
        writable: !0,
        configurable: !1,
        enumerable: !0,
        value: null
      },
      attributeNameCheck: {
        writable: !0,
        configurable: !1,
        enumerable: !0,
        value: null
      },
      allowCustomizedBuiltInElements: {
        writable: !0,
        configurable: !1,
        enumerable: !0,
        value: !1
      }
    })), $ = null, ye = null, et = !0, Oe = !0, tt = !1, nt = !0, P = !1, ie = !0, w = !1, Le = !1, De = !1, v = !1, ae = !1, re = !1, ot = !0, it = !1;
    const rn = "user-content-";
    let Ne = !0, K = !1, k = {}, U = null;
    const at = a({}, ["annotation-xml", "audio", "colgroup", "desc", "foreignobject", "head", "iframe", "math", "mi", "mn", "mo", "ms", "mtext", "noembed", "noframes", "noscript", "plaintext", "script", "style", "svg", "template", "thead", "title", "video", "xmp"]);
    let rt = null;
    const st = a({}, ["audio", "video", "img", "source", "image", "track"]);
    let be = null;
    const lt = a({}, ["alt", "class", "for", "id", "label", "name", "pattern", "placeholder", "role", "summary", "title", "value", "style", "xmlns"]), se = "http://www.w3.org/1998/Math/MathML", le = "http://www.w3.org/2000/svg", I = "http://www.w3.org/1999/xhtml";
    let F = I, Ie = !1, Me = null;
    const sn = a({}, [se, le, I], pe);
    let ce = a({}, ["mi", "mo", "mn", "ms", "mtext"]), fe = a({}, ["annotation-xml"]);
    const ln = a({}, ["title", "style", "font", "a", "script"]);
    let Z = null;
    const cn = ["application/xhtml+xml", "text/html"], fn = "text/html";
    let p = null, H = null;
    const un = l.createElement("form"), ct = function(e) {
      return e instanceof RegExp || e instanceof Function;
    }, Ce = function() {
      let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
      if (!(H && H === e)) {
        if ((!e || typeof e != "object") && (e = {}), e = N(e), Z = // eslint-disable-next-line unicorn/prefer-includes
        cn.indexOf(e.PARSER_MEDIA_TYPE) === -1 ? fn : e.PARSER_MEDIA_TYPE, p = Z === "application/xhtml+xml" ? pe : ee, m = L(e, "ALLOWED_TAGS") ? a({}, e.ALLOWED_TAGS, p) : Je, d = L(e, "ALLOWED_ATTR") ? a({}, e.ALLOWED_ATTR, p) : Qe, Me = L(e, "ALLOWED_NAMESPACES") ? a({}, e.ALLOWED_NAMESPACES, pe) : sn, be = L(e, "ADD_URI_SAFE_ATTR") ? a(N(lt), e.ADD_URI_SAFE_ATTR, p) : lt, rt = L(e, "ADD_DATA_URI_TAGS") ? a(N(st), e.ADD_DATA_URI_TAGS, p) : st, U = L(e, "FORBID_CONTENTS") ? a({}, e.FORBID_CONTENTS, p) : at, $ = L(e, "FORBID_TAGS") ? a({}, e.FORBID_TAGS, p) : N({}), ye = L(e, "FORBID_ATTR") ? a({}, e.FORBID_ATTR, p) : N({}), k = L(e, "USE_PROFILES") ? e.USE_PROFILES : !1, et = e.ALLOW_ARIA_ATTR !== !1, Oe = e.ALLOW_DATA_ATTR !== !1, tt = e.ALLOW_UNKNOWN_PROTOCOLS || !1, nt = e.ALLOW_SELF_CLOSE_IN_ATTR !== !1, P = e.SAFE_FOR_TEMPLATES || !1, ie = e.SAFE_FOR_XML !== !1, w = e.WHOLE_DOCUMENT || !1, v = e.RETURN_DOM || !1, ae = e.RETURN_DOM_FRAGMENT || !1, re = e.RETURN_TRUSTED_TYPE || !1, De = e.FORCE_BODY || !1, ot = e.SANITIZE_DOM !== !1, it = e.SANITIZE_NAMED_PROPS || !1, Ne = e.KEEP_CONTENT !== !1, K = e.IN_PLACE || !1, Ze = e.ALLOWED_URI_REGEXP || Ye, F = e.NAMESPACE || I, ce = e.MATHML_TEXT_INTEGRATION_POINTS || ce, fe = e.HTML_INTEGRATION_POINTS || fe, f = e.CUSTOM_ELEMENT_HANDLING || {}, e.CUSTOM_ELEMENT_HANDLING && ct(e.CUSTOM_ELEMENT_HANDLING.tagNameCheck) && (f.tagNameCheck = e.CUSTOM_ELEMENT_HANDLING.tagNameCheck), e.CUSTOM_ELEMENT_HANDLING && ct(e.CUSTOM_ELEMENT_HANDLING.attributeNameCheck) && (f.attributeNameCheck = e.CUSTOM_ELEMENT_HANDLING.attributeNameCheck), e.CUSTOM_ELEMENT_HANDLING && typeof e.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements == "boolean" && (f.allowCustomizedBuiltInElements = e.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements), P && (Oe = !1), ae && (v = !0), k && (m = a({}, Ge), d = [], k.html === !0 && (a(m, ze), a(d, We)), k.svg === !0 && (a(m, de), a(d, Ee), a(d, te)), k.svgFilters === !0 && (a(m, Te), a(d, Ee), a(d, te)), k.mathMl === !0 && (a(m, _e), a(d, Be), a(d, te))), e.ADD_TAGS && (m === Je && (m = N(m)), a(m, e.ADD_TAGS, p)), e.ADD_ATTR && (d === Qe && (d = N(d)), a(d, e.ADD_ATTR, p)), e.ADD_URI_SAFE_ATTR && a(be, e.ADD_URI_SAFE_ATTR, p), e.FORBID_CONTENTS && (U === at && (U = N(U)), a(U, e.FORBID_CONTENTS, p)), Ne && (m["#text"] = !0), w && a(m, ["html", "head", "body"]), m.table && (a(m, ["tbody"]), delete $.tbody), e.TRUSTED_TYPES_POLICY) {
          if (typeof e.TRUSTED_TYPES_POLICY.createHTML != "function")
            throw B('TRUSTED_TYPES_POLICY configuration option must provide a "createHTML" hook.');
          if (typeof e.TRUSTED_TYPES_POLICY.createScriptURL != "function")
            throw B('TRUSTED_TYPES_POLICY configuration option must provide a "createScriptURL" hook.');
          S = e.TRUSTED_TYPES_POLICY, q = S.createHTML("");
        } else
          S === void 0 && (S = Wt(ne, T)), S !== null && typeof q == "string" && (q = S.createHTML(""));
        g && g(e), H = e;
      }
    }, ft = a({}, [...de, ...Te, ...Ct]), ut = a({}, [..._e, ...wt]), mn = function(e) {
      let t = oe(e);
      (!t || !t.tagName) && (t = {
        namespaceURI: F,
        tagName: "template"
      });
      const n = ee(e.tagName), c = ee(t.tagName);
      return Me[e.namespaceURI] ? e.namespaceURI === le ? t.namespaceURI === I ? n === "svg" : t.namespaceURI === se ? n === "svg" && (c === "annotation-xml" || ce[c]) : !!ft[n] : e.namespaceURI === se ? t.namespaceURI === I ? n === "math" : t.namespaceURI === le ? n === "math" && fe[c] : !!ut[n] : e.namespaceURI === I ? t.namespaceURI === le && !fe[c] || t.namespaceURI === se && !ce[c] ? !1 : !ut[n] && (ln[n] || !ft[n]) : !!(Z === "application/xhtml+xml" && Me[e.namespaceURI]) : !1;
    }, D = function(e) {
      G(o.removed, {
        element: e
      });
      try {
        oe(e).removeChild(e);
      } catch {
        qt(e);
      }
    }, z = function(e, t) {
      try {
        G(o.removed, {
          attribute: t.getAttributeNode(e),
          from: t
        });
      } catch {
        G(o.removed, {
          attribute: null,
          from: t
        });
      }
      if (t.removeAttribute(e), e === "is")
        if (v || ae)
          try {
            D(t);
          } catch {
          }
        else
          try {
            t.setAttribute(e, "");
          } catch {
          }
    }, mt = function(e) {
      let t = null, n = null;
      if (De)
        e = "<remove></remove>" + e;
      else {
        const u = He(e, /^[\r\n\t ]+/);
        n = u && u[0];
      }
      Z === "application/xhtml+xml" && F === I && (e = '<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body>' + e + "</body></html>");
      const c = S ? S.createHTML(e) : e;
      if (F === I)
        try {
          t = new jt().parseFromString(c, Z);
        } catch {
        }
      if (!t || !t.documentElement) {
        t = he.createDocument(F, "template", null);
        try {
          t.documentElement.innerHTML = Ie ? q : c;
        } catch {
        }
      }
      const _ = t.body || t.documentElement;
      return e && n && _.insertBefore(l.createTextNode(n), _.childNodes[0] || null), F === I ? Qt.call(t, w ? "html" : "body")[0] : w ? t.documentElement : _;
    }, pt = function(e) {
      return Zt.call(
        e.ownerDocument || e,
        e,
        // eslint-disable-next-line no-bitwise
        j.SHOW_ELEMENT | j.SHOW_COMMENT | j.SHOW_TEXT | j.SHOW_PROCESSING_INSTRUCTION | j.SHOW_CDATA_SECTION,
        null
      );
    }, we = function(e) {
      return e instanceof Xt && (typeof e.nodeName != "string" || typeof e.textContent != "string" || typeof e.removeChild != "function" || !(e.attributes instanceof Yt) || typeof e.removeAttribute != "function" || typeof e.setAttribute != "function" || typeof e.namespaceURI != "string" || typeof e.insertBefore != "function" || typeof e.hasChildNodes != "function");
    }, dt = function(e) {
      return typeof ge == "function" && e instanceof ge;
    };
    function M(i, e, t) {
      Q(i, (n) => {
        n.call(o, e, t, H);
      });
    }
    const Tt = function(e) {
      let t = null;
      if (M(R.beforeSanitizeElements, e, null), we(e))
        return D(e), !0;
      const n = p(e.nodeName);
      if (M(R.uponSanitizeElement, e, {
        tagName: n,
        allowedTags: m
      }), ie && e.hasChildNodes() && !dt(e.firstElementChild) && h(/<[/\w!]/g, e.innerHTML) && h(/<[/\w!]/g, e.textContent) || e.nodeType === X.progressingInstruction || ie && e.nodeType === X.comment && h(/<[/\w]/g, e.data))
        return D(e), !0;
      if (!m[n] || $[n]) {
        if (!$[n] && Et(n) && (f.tagNameCheck instanceof RegExp && h(f.tagNameCheck, n) || f.tagNameCheck instanceof Function && f.tagNameCheck(n)))
          return !1;
        if (Ne && !U[n]) {
          const c = oe(e) || e.parentNode, _ = Kt(e) || e.childNodes;
          if (_ && c) {
            const u = _.length;
            for (let y = u - 1; y >= 0; --y) {
              const C = Vt(_[y], !0);
              C.__removalCount = (e.__removalCount || 0) + 1, c.insertBefore(C, $t(e));
            }
          }
        }
        return D(e), !0;
      }
      return e instanceof $e && !mn(e) || (n === "noscript" || n === "noembed" || n === "noframes") && h(/<\/no(script|embed|frames)/i, e.innerHTML) ? (D(e), !0) : (P && e.nodeType === X.text && (t = e.textContent, Q([Ae, Se, Re], (c) => {
        t = W(t, c, " ");
      }), e.textContent !== t && (G(o.removed, {
        element: e.cloneNode()
      }), e.textContent = t)), M(R.afterSanitizeElements, e, null), !1);
    }, _t = function(e, t, n) {
      if (ot && (t === "id" || t === "name") && (n in l || n in un))
        return !1;
      if (!(Oe && !ye[t] && h(tn, t))) {
        if (!(et && h(nn, t))) {
          if (!d[t] || ye[t]) {
            if (
              // First condition does a very basic check if a) it's basically a valid custom element tagname AND
              // b) if the tagName passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
              // and c) if the attribute name passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.attributeNameCheck
              !(Et(e) && (f.tagNameCheck instanceof RegExp && h(f.tagNameCheck, e) || f.tagNameCheck instanceof Function && f.tagNameCheck(e)) && (f.attributeNameCheck instanceof RegExp && h(f.attributeNameCheck, t) || f.attributeNameCheck instanceof Function && f.attributeNameCheck(t)) || // Alternative, second condition checks if it's an `is`-attribute, AND
              // the value passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
              t === "is" && f.allowCustomizedBuiltInElements && (f.tagNameCheck instanceof RegExp && h(f.tagNameCheck, n) || f.tagNameCheck instanceof Function && f.tagNameCheck(n)))
            ) return !1;
          } else if (!be[t]) {
            if (!h(Ze, W(n, Ke, ""))) {
              if (!((t === "src" || t === "xlink:href" || t === "href") && e !== "script" && Nt(n, "data:") === 0 && rt[e])) {
                if (!(tt && !h(on, W(n, Ke, "")))) {
                  if (n)
                    return !1;
                }
              }
            }
          }
        }
      }
      return !0;
    }, Et = function(e) {
      return e !== "annotation-xml" && He(e, an);
    }, gt = function(e) {
      M(R.beforeSanitizeAttributes, e, null);
      const {
        attributes: t
      } = e;
      if (!t || we(e))
        return;
      const n = {
        attrName: "",
        attrValue: "",
        keepAttr: !0,
        allowedAttributes: d,
        forceKeepAttr: void 0
      };
      let c = t.length;
      for (; c--; ) {
        const _ = t[c], {
          name: u,
          namespaceURI: y,
          value: C
        } = _, J = p(u), xe = C;
        let E = u === "value" ? xe : bt(xe);
        if (n.attrName = J, n.attrValue = E, n.keepAttr = !0, n.forceKeepAttr = void 0, M(R.uponSanitizeAttribute, e, n), E = n.attrValue, it && (J === "id" || J === "name") && (z(u, e), E = rn + E), ie && h(/((--!?|])>)|<\/(style|title)/i, E)) {
          z(u, e);
          continue;
        }
        if (n.forceKeepAttr)
          continue;
        if (!n.keepAttr) {
          z(u, e);
          continue;
        }
        if (!nt && h(/\/>/i, E)) {
          z(u, e);
          continue;
        }
        P && Q([Ae, Se, Re], (At) => {
          E = W(E, At, " ");
        });
        const ht = p(e.nodeName);
        if (!_t(ht, J, E)) {
          z(u, e);
          continue;
        }
        if (S && typeof ne == "object" && typeof ne.getAttributeType == "function" && !y)
          switch (ne.getAttributeType(ht, J)) {
            case "TrustedHTML": {
              E = S.createHTML(E);
              break;
            }
            case "TrustedScriptURL": {
              E = S.createScriptURL(E);
              break;
            }
          }
        if (E !== xe)
          try {
            y ? e.setAttributeNS(y, u, E) : e.setAttribute(u, E), we(e) ? D(e) : Fe(o.removed);
          } catch {
            z(u, e);
          }
      }
      M(R.afterSanitizeAttributes, e, null);
    }, pn = function i(e) {
      let t = null;
      const n = pt(e);
      for (M(R.beforeSanitizeShadowDOM, e, null); t = n.nextNode(); )
        M(R.uponSanitizeShadowNode, t, null), Tt(t), gt(t), t.content instanceof b && i(t.content);
      M(R.afterSanitizeShadowDOM, e, null);
    };
    return o.sanitize = function(i) {
      let e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, t = null, n = null, c = null, _ = null;
      if (Ie = !i, Ie && (i = "<!-->"), typeof i != "string" && !dt(i))
        if (typeof i.toString == "function") {
          if (i = i.toString(), typeof i != "string")
            throw B("dirty is not a string, aborting");
        } else
          throw B("toString is not a function");
      if (!o.isSupported)
        return i;
      if (Le || Ce(e), o.removed = [], typeof i == "string" && (K = !1), K) {
        if (i.nodeName) {
          const C = p(i.nodeName);
          if (!m[C] || $[C])
            throw B("root node is forbidden and cannot be sanitized in-place");
        }
      } else if (i instanceof ge)
        t = mt("<!---->"), n = t.ownerDocument.importNode(i, !0), n.nodeType === X.element && n.nodeName === "BODY" || n.nodeName === "HTML" ? t = n : t.appendChild(n);
      else {
        if (!v && !P && !w && // eslint-disable-next-line unicorn/prefer-includes
        i.indexOf("<") === -1)
          return S && re ? S.createHTML(i) : i;
        if (t = mt(i), !t)
          return v ? null : re ? q : "";
      }
      t && De && D(t.firstChild);
      const u = pt(K ? i : t);
      for (; c = u.nextNode(); )
        Tt(c), gt(c), c.content instanceof b && pn(c.content);
      if (K)
        return i;
      if (v) {
        if (ae)
          for (_ = Jt.call(t.ownerDocument); t.firstChild; )
            _.appendChild(t.firstChild);
        else
          _ = t;
        return (d.shadowroot || d.shadowrootmode) && (_ = en.call(s, _, !0)), _;
      }
      let y = w ? t.outerHTML : t.innerHTML;
      return w && m["!doctype"] && t.ownerDocument && t.ownerDocument.doctype && t.ownerDocument.doctype.name && h(Xe, t.ownerDocument.doctype.name) && (y = "<!DOCTYPE " + t.ownerDocument.doctype.name + `>
` + y), P && Q([Ae, Se, Re], (C) => {
        y = W(y, C, " ");
      }), S && re ? S.createHTML(y) : y;
    }, o.setConfig = function() {
      let i = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
      Ce(i), Le = !0;
    }, o.clearConfig = function() {
      H = null, Le = !1;
    }, o.isValidAttribute = function(i, e, t) {
      H || Ce({});
      const n = p(i), c = p(e);
      return _t(n, c, t);
    }, o.addHook = function(i, e) {
      typeof e == "function" && G(R[i], e);
    }, o.removeHook = function(i, e) {
      if (e !== void 0) {
        const t = Lt(R[i], e);
        return t === -1 ? void 0 : Dt(R[i], t, 1)[0];
      }
      return Fe(R[i]);
    }, o.removeHooks = function(i) {
      R[i] = [];
    }, o.removeAllHooks = function() {
      R = Ve();
    }, o;
  }
  var Bt = qe();
  return Pe = Bt, Pe;
}
export {
  dn as __require
};
